export const APP_CONFIG = "APP_CONFIG";
export const CREATE_PRODUCT = "CREATE_PRODUCT";

export const USER_LOADED = "USER_LOADED";
export const USER_LOADING = "USER_LOADING";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const UPDATE_PROFILE_LOADING = "UPDATE_PROFILE_LOADING";
export const UPDATE_PROFILE_ERROR = "UPDATE_PROFILE_ERROR";
export const GET_FIREBASE_TOKEN = "GET_FIREBASE_TOKEN";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const DELETE_CHAT = "DELETE_CHAT";
export const SET_MESSAGE_DELETED = "SET_MESSAGE_DELETED";
export const STARR_MESSAGE_CHANGE = "STARR_MESSAGE_CHANGE";
export const CHANGE_MESSAGE_REACT = "CHANGE_MESSAGE_REACT";
export const REMOVE_MESSAGES = "REMOVE_MESSAGES";

export const INTERACTIVE_LOADING = "INTERACTIVE_LOADING";
export const LOAD_INTERACTIVE_ERROR = "LOAD_INTERACTIVE_ERROR";
export const LOAD_INTERACTIVE = "LOAD_INTERACTIVE";

export const LOG_IN = "LOG_IN";
export const LOG_OUT = "LOG_OUT";
export const SET_SESSION = "SET_SESSION";

export const CHOOSE_POLL_OPTION = "CHOOSE_POLL_OPTION";
export const DELETE_CHOICE_POLL_OPTION = "DELETE_CHOICE_POLL_OPTION";
export const CHOOSE_MESSAGE_POLL_OPTION = "CHOOSE_MESSAGE_POLL_OPTION";
export const UPDATE_POLL_OPTION = "UPDATE_POLL_OPTION";

export const LOAD_POSTS = "LOAD_POSTS";
export const LOAD_POSTS_ERROR = "LOAD_POSTS_ERROR";
export const LOAD_POSTS_LOADING = "LOAD_POSTS_LOADING";

/// Event Reducer
export const EVENTS_LOADING = "EVENTS_LOADING";
export const LOAD_EVENTS = "LOAD_EVENTS";
export const LOAD_EVENTS_ERROR = "LOAD_EVENTS_ERROR";
export const NEW_EVENT_LOADING = "NEW_EVENT_LOADING";
export const CREATE_NEW_EVENT = "CREATE_NEW_EVENT";
export const NEW_EVENT_ERROR = "NEW_EVENT_ERROR";

export const SINGLE_EVENT_LOADING = "SINGLE_EVENT_LOADING";
export const SINGLE_EVENT_ERROR = "SINGLE_EVENT_ERROR";
export const SINGLE_EVENT_LOAD = "SINGLE_EVENT_LOAD";
export const CHANGE_EVENT_STATUS = "CHANGE_EVENT_STATUS";
export const DELETE_EVENT = "DELETE_EVENT";
export const GET_EVENT_INVITEES = "GET_EVENT_INVITEES";
export const GET_EVENT_INVITEES_LOADING = "GET_EVENT_INVITEES_LOADING";
export const GET_EVENT_INVITEES_ERROR = "GET_EVENT_INVITEES_ERROR";
export const UPDATE_EVENT_INVITEES = "UPDATE_EVENT_INVITEES";

export const EVENT_LIVE_LOADING = "EVENT_LIVE_LOADING";
export const EVENT_LIVE_ERROR = "EVENT_LIVE_ERROR";
export const EVENT_LIVE_LOAD = "EVENT_LIVE_LOAD";

export const EVENTS_TYPE_LOADING = "EVENTS_TYPE_LOADING";
export const LOAD_EVENTS_TYPE_ERROR = "LOAD_EVENTS_TYPE_ERROR";
export const LOAD_EVENTS_TYPE = "LOAD_EVENTS_TYPE";

export const CREATE_SESSION_LOADING = "CREATE_SESSION_LOADING";
export const CREATE_SESSION_ERROR = "CREATE_SESSION_ERROR";
export const UPDATE_SESSION = "UPDATE_SESSION";

export const JOIN_POST_EVENT = "JOIN_POST_EVENT";
export const UPDATE_POST = "UPDATE_POST";

//Categories
export const CATEGORIES_LOADING = "CATEGORIES_LOADING";
export const CATEGORIES_ERROR = "CATEGORIES_ERROR";
export const CATEGORIES_LIST = "CATEGORIES_LIST";

//Video
export const VIDEO_LOADING = "VIDEO_LOADING";
export const VIDEO_ERROR = "VIDEO_ERROR";
export const VIDEO_LIST = "VIDEO_LIST";

//Comments
export const LOAD_COMMENTS = "LOAD_COMMENTS";
export const LOAD_COMMENTS_ERROR = "LOAD_COMMENTS_ERROR";
export const LOAD_COMMENTS_LOADING = "LOAD_COMMENTS_LOADING";
export const INSERT_COMMENT = "INSERT_COMMENT";
export const DELETE_COMMENT = "DELETE_COMMENT";
export const UPDATE_COMMENT = "UPDATE_COMMENT";
export const CHANGE_REACT = "CHANGE_REACT";

///REPLIES
export const INSERT_REPLY = "INSERT_REPLY";
export const DELETE_REPLY = "DELETE_REPLY";
export const UPDATE_REPLY = "UPDATE_REPLY";

export const SOCKETCONNECTED = "SOCKETCONNECTED";

//Chats
export const CHATS_LOADED = "CHATS_LOADED";
export const ADD_SINGLE_CHAT = "ADD_SINGLE_CHAT";
export const CHATS_LOADING = "CHATS_LOADING";
export const CHATS_ERROR = "CHATS_ERROR";
export const UPDATE_CHATS_WHEN_MESSAGE_GOT = "UPDATE_CHATS_WHEN_MESSAGE_GOT";
export const UPDATE_CHAT_UNSEEN_MESSAGE_COUNT =
  "UPDATE_CHAT_UNSEEN_MESSAGE_COUNT";
export const ADD_CHAT_MEMBERS = "ADD_CHAT_MEMBERS";
export const DELETE_CHAT_MEMBER = "DELETE_CHAT_MEMBER";
export const CHANGE_CHATS_TAB = "CHANGE_CHATS_TAB";

//Chat Threads
export const GET_THREADS = "GET_THREADS";
export const THREADS_LOADING = "THREADS_LOADING";
export const THREADS_ERROR = "THREADS_ERROR";

//SingleChat
export const SINGLE_CHAT_LOADED = "SINGLE_CHAT_LOADED";
export const SINGLE_CHAT_LOADING = "SINGLE_CHAT_LOADING";
export const SINGLE_CHAT_ERROR = "SINGLE_CHAT_ERROR";
export const SET_TEMP_CHAT = "SET_TEMP_CHAT";
export const INSERT_NEW_MESSAGE = "INSERT_NEW_MESSAGE";
export const CONVERT_MESSAGE = "CONVERT_MESSAGE";
export const MESSAGE_SENT = "MESSAGE_SENT";
export const INSERT_NEW_GROUP = "INSERT_NEW_GROUP";
export const UPDATE_CHAT_INFO = "UPDATE_CHAT_INFO";
export const EMPTY_SINGLE_CHAT = "EMPTY_SINGLE_CHAT";
export const CLEAR_CHAT_MESSAGES = "CLEAR_CHAT_MESSAGES";
//Contacts
export const CONTACTS_LOADED = "CONTACTS_LOADED";
export const CONTACTS_LOADING = "CONTACTS_LOADING";
export const CONTACTS_ERROR = "CONTACTS_ERROR";
export const CREATE_NEW_CONTACT = "CREATE_NEW_CONTACT";
export const DELETE_CONTACT = "DELETE_CONTACT";
export const ADD_USER_TO_CONTACT = "ADD_USER_TO_CONTACT";

/// nOTIFICATIONS
export const LIST_NOTIFICATIONS = "LIST_NOTIFICATIONS";
export const LIST_NOTIFICATIONS_LOADING = "LIST_NOTIFICATIONS_LOADING";
export const LIST_NOTIFICATIONS_ERROR = "LIST_NOTIFICATIONS_ERROR";
export const INSERT_NEW_NOTIFICATION = "INSERT_NEW_NOTIFICATION";
export const UPDATE_UN_READ = "UPDATE_UN_READ";
export const LIST_NOTIFICATIONS_NO_ACTION_LOADING =
  "LIST_NOTIFICATIONS_NO_ACTION_LOADING";
export const LIST_NOTIFICATIONS_NO_ACTION_ERROR =
  "LIST_NOTIFICATIONS_NO_ACTION_ERROR";
export const LIST_NOTIFICATIONS_NO_ACTION = "LIST_NOTIFICATIONS_NO_ACTION";

export const LIST_NOTIFICATIONS_ACTION_LOADING =
  "LIST_NOTIFICATIONS_ACTION_LOADING";
export const LIST_NOTIFICATIONS_ACTION_ERROR =
  "LIST_NOTIFICATIONS_ACTION_ERROR";
export const LIST_NOTIFICATIONS_ACTION = "LIST_NOTIFICATIONS_ACTION";

export const CHANGE_EVENT = "CHANGE_EVENT";
export const CHANGE_TASK = "CHANGE_TASK";

export const BUZZED = "BUZZED";
export const START_SHAKING = "START_SHAKING";
export const STOP_SHAKING = "STOP_SHAKING";

///Users
export const SET_CURRENT_USERS = "SET_CURRENT_USERS";
export const CHANGE_USER_STATUS = "CHANGE_USER_STATUS";

export const LIST_INTERACTIVE = "LIST_INTERACTIVE";

